<template>
  <div>
    <div class="marketing-info" v-show="!isInit.isInit">
      <div
        class="marketing-items fixed-top"
        :class="{ 'is-visible': isTopVisible }"
      >
        <div
          class="marketing-item"
          v-for="(item, index) in marketingItems"
          :key="index"
          @click="marketingItemChange(item)"
        >
          <span :class="{ isactive: item.isActive }">{{ item.name }}</span>
          <i class="el-icon-success success-icon" v-if="item.status"></i>
          <i class="el-icon-success" v-else></i>
        </div>
      </div>
      <div class="marketing-items" ref="marketingItems">
        <div
          class="marketing-item"
          v-for="(item, index) in marketingItems"
          :key="index"
          @click="marketingItemChange(item)"
        >
          <span :class="{ isactive: item.isActive }">{{ item.name }}</span>
          <i class="el-icon-success success-icon" v-if="item.status"></i>
          <i class="el-icon-success" v-else></i>
        </div>
      </div>
      <div class="detail-main">
        <div class="detail-item estate-basic" ref="commissionPlan">
          <div class="detail-title">
            佣金方案
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="editModule('commissionPlan')"
              >添加</el-button
            >
          </div>
          <div class="detail-item-main">
            <el-table :data="commissions" border>
              <el-table-column prop="name" label="方案名称"> </el-table-column>
              <el-table-column prop="type" label="佣金类型"> </el-table-column>
              <el-table-column prop="amount" label="佣金金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.amount }}</span>
                  <span>{{ scope.row.type == "按套" ? "元" : "%" }}</span>
                </template>
              </el-table-column>
              <el-table-column prop="rule" label="佣金规则"> </el-table-column>
              <el-table-column label="操作" width="135" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation">
                    <el-button
                      @click.native.prevent="editCommissionPlan(scope.row)"
                      type="text"
                      >编辑</el-button
                    >
                    <el-button
                      @click.native.prevent="
                        updateCommissionDisable(
                          scope.row.id,
                          scope.row.isDisable
                        )
                      "
                      type="text"
                      >{{ scope.row.isDisable ? "显示" : "隐藏" }}</el-button
                    >
                    <el-popover placement="bottom" trigger="click">
                      <el-button
                        @click.native.prevent="delCommissionPlan(scope.row.id)"
                        type="text"
                        class="del-btn"
                        >删除</el-button
                      >
                      <el-button slot="reference" type="text" class="more-btn"
                        >更多</el-button
                      >
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="detail-item project-counselors" ref="projectRule">
          <div class="detail-title">项目规则</div>
          <div class="detail-item-main project-counselor">
            <div class="rule-box">
              <div class="rule-title">报备规则</div>
              <div class="rule-items flex-between">
                <div>
                  <div>
                    <span class="rule-item"
                      >报备号码：{{
                        reservationRule.numberType | nullValue
                      }}</span
                    >
                    <span
                      >报备有效期：<span v-if="reservationRule.protectedNumber"
                        >{{ reservationRule.protectedNumber | nullValue }}
                        {{ reservationRule.protectedUnit }}</span
                      ><span v-else>—</span></span
                    >
                  </div>
                  <div>报备注意事项：{{ reservationRule.more | nullValue }}</div>
                  <div>
                    自定义字段：
                    <span
                      v-for="(item, index) in reservationRule.fields"
                      :key="index"
                      class="fields-value"
                    >
                      {{ item.name }}
                    </span>
                    <span v-if="!reservationRule.fields.length">—</span>
                  </div>
                </div>
                <div class="rule-btn" @click="editModule('reservationRule')">
                  编辑
                </div>
              </div>
            </div>
            <div class="rule-box">
              <div class="rule-title">来访规则</div>
              <div class="rule-items flex-between">
                <div>
                  <div>
                    <span class="rule-item"
                      >来访保护期：<span v-if="visitRule.protectedNumber"
                        >{{ visitRule.protectedNumber | nullValue }}
                        {{ visitRule.protectedUnit }}</span
                      ><span v-else>—</span></span
                    >
                    <span class="rule-item"
                      >来访登记：{{ visitRule.registerType | nullValue }}</span
                    >
                    <span
                      >来访确认：{{ visitRule.validationType | nullValue }}</span
                    >
                  </div>
                  <div>备注：{{ visitRule.more | nullValue }}</div>
                </div>
                <div class="rule-btn" @click="editModule('visitRule')">编辑</div>
              </div>
            </div>
            <div class="rule-box">
              <div class="rule-title">结佣规则</div>
              <div class="rule-items flex-between">
                <div>
                  <div>
                    结佣方式：{{
                      settlementRule.more ? settlementRule.settlementType : "—"
                    }}
                  </div>
                  <div>备注：{{ settlementRule.more | nullValue }}</div>
                </div>
                <div class="rule-btn" @click="editModule('settlementRule')">
                  编辑
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="detail-item sale-point" ref="award">
          <div class="detail-title">
            奖励方案
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="editModule('award')"
              >添加</el-button
            >
          </div>
          <div class="detail-item-main">
            <el-table :data="awards" border class="sort-table">
              <el-table-column prop="type" label="奖励类型"> </el-table-column>
              <el-table-column prop="amount" label="奖励金额">
              </el-table-column>
              <el-table-column prop="enableStartTime" label="奖励时间" sortable>
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.enableStartTime | dateFormatYMD }} ~
                    {{ scope.row.enableEndTime | dateFormatYMD }}</span
                  >
                </template>
              </el-table-column>
              <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation">
                    <el-button
                      @click.native.prevent="editAward(scope.row)"
                      type="text"
                      >编辑</el-button
                    >
                    <el-button
                      @click.native.prevent="
                        updateAwardDisable(scope.row.id, scope.row.isDisable)
                      "
                      type="text"
                      >{{ scope.row.isDisable ? "显示" : "隐藏" }}</el-button
                    >
                    <!-- <el-button
                      @click.native.prevent="editCommissionPlan(scope.row)"
                      type="text"
                      >置顶</el-button
                    > -->
                    <el-popover placement="bottom" trigger="click">
                      <el-button
                        @click.native.prevent="delAward(scope.row.id)"
                        type="text"
                        class="del-btn"
                        >删除</el-button
                      >
                      <el-button slot="reference" type="text" class="more-btn"
                        >更多</el-button
                      >
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
        <div class="detail-item estate-basic" ref="dynamic">
          <div class="detail-title">
            项目动态
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="editModule('dynamic')"
              >添加</el-button
            >
          </div>
          <div class="detail-item-main">
            <el-table :data="dynamics" border class="sort-table">
              <el-table-column prop="name" label="动态名称"> </el-table-column>
              <el-table-column prop="content" label="动态内容">
              </el-table-column>
              <el-table-column prop="publishTime" label="发布时间" sortable>
                <template slot-scope="scope">
                  {{ scope.row.publishTime | dateFormatYMD }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="172" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation">
                    <el-button
                      @click.native.prevent="editDynamic(scope.row)"
                      type="text"
                      >编辑</el-button
                    >
                    <el-button
                      :disabled="scope.row.isPublish"
                      @click.native.prevent="publishDynamic(scope.row.id)"
                      type="text"
                      >发布</el-button
                    >
                    <el-button
                      :disabled="scope.row.isTop"
                      @click.native.prevent="topDynamic(scope.row.id)"
                      type="text"
                      >置顶</el-button
                    >
                    <el-popover placement="bottom" trigger="click">
                      <el-button
                        @click.native.prevent="deleteDynamic(scope.row.id)"
                        type="text"
                        class="del-btn"
                        >删除</el-button
                      >
                      <el-button slot="reference" type="text" class="more-btn"
                        >更多</el-button
                      >
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <el-pagination
              class="pagination"
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page.sync="pageIndex"
              :page-sizes="[20, 50, 100]"
              :page-size="maxResultCount"
              layout="total, sizes, prev, pager, next, jumper"
              :total="totalCount"
            ></el-pagination>
          </div>
        </div>
        <div class="detail-item estate-map" ref="estateGroup">
          <div class="detail-title">
            团购方案
            <el-button
              type="primary"
              icon="el-icon-plus"
              @click="editModule('group')"
              >添加</el-button
            >
          </div>
          <div class="detail-item-main">
            <el-table :data="groups" border>
              <el-table-column prop="type" label="团购类型"> </el-table-column>
              <el-table-column prop="amount" label="团购金额">
              </el-table-column>
              \
              <el-table-column label="操作" width="180" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation">
                    <el-button
                      @click.native.prevent="editGroup(scope.row)"
                      type="text"
                      >编辑</el-button
                    >
                    <el-button
                      @click.native.prevent="
                        updateGroupDisable(scope.row.id, scope.row.isDisable)
                      "
                      type="text"
                      >{{ scope.row.isDisable ? "显示" : "隐藏" }}</el-button
                    >
                    <!-- <el-button
                      @click.native.prevent="editCommissionPlan(scope.row)"
                      type="text"
                      >置顶</el-button
                    > -->
                    <el-popover placement="bottom" trigger="click">
                      <el-button
                        @click.native.prevent="delGroup(scope.row.id)"
                        type="text"
                        class="del-btn"
                        >删除</el-button
                      >
                      <el-button slot="reference" type="text" class="more-btn"
                        >更多</el-button
                      >
                    </el-popover>
                  </div>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </div>
      <el-dialog
        :title="commissionPlanTitle"
        :visible.sync="isEditInfo.commissionPlan"
        @close="handleClose('commissionPlanForm')"
      >
        <el-form
          label-position="left"
          label-width="5rem"
          ref="commissionPlanForm"
          :rules="commissionPlanRules"
          :model="commissionPlanForm"
        >
          <div class="flex-form">
            <el-form-item label="方案名称" prop="name" class="margin-right">
              <el-input
                v-model="commissionPlanForm.name"
                placeholder="请输入方案名称"
                clearable
              >
              </el-input>
            </el-form-item>
            <el-form-item label="佣金类型" prop="type">
              <el-radio-group v-model="commissionPlanForm.type">
                <el-radio
                  v-for="item in commissionTypeOptions"
                  :label="item"
                  :key="item"
                  >{{ item }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="佣金金额" prop="amount">
            <el-input
              v-model="commissionPlanForm.amount"
              placeholder="请输入佣金金额"
              clearable
              type="number"
            >
              <template slot="append">{{ commissionAmountUnit }}</template>
            </el-input>
          </el-form-item>
          <el-form-item label="佣金规则" class="auto-height" prop="rule">
            <el-input
              type="textarea"
              v-model="commissionPlanForm.rule"
              placeholder="请输入佣金规则"
              show-word-limit
              maxlength="500"
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.commissionPlan = false"
              >取 消</el-button
            >
            <el-button
              type="primary"
              @click="submitCommissionPlan"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="编辑报备规则"
        :visible.sync="isEditInfo.reservationRule"
        @close="handleClose('reservationRuleForm')"
      >
        <el-form
          label-position="left"
          label-width="7rem"
          ref="reservationRuleForm"
          :rules="creservationRules"
          :model="reservationRuleForm"
        >
          <el-form-item label="报备号码" prop="numberType">
            <el-radio-group v-model="reservationRuleForm.numberType">
              <el-radio
                v-for="(item, key) in numberTypeOptions"
                :label="key"
                :key="key"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <div class="flex-form">
            <el-form-item
              label="报备有效期"
              prop="protectedNumber"
              class="margin-right"
            >
              <el-input
                v-model="reservationRuleForm.protectedNumber"
                placeholder="请输入报备有效期"
                clearable
                type="number"
              >
                <template slot="append">{{ reservationUnit }}</template>
              </el-input>
            </el-form-item>
            <el-form-item label="有效期单位" prop="protectedUnit">
              <el-radio-group v-model="reservationRuleForm.protectedUnit">
                <el-radio
                  v-for="item in protectedUnitOptions"
                  :label="item.value"
                  :key="item.label"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="报备注意事项" class="auto-height" prop="more">
            <el-input
              type="textarea"
              v-model="reservationRuleForm.more"
              placeholder="请输入报备注意事项"
              show-word-limit
              maxlength="500"
              resize="none"
            ></el-input>
          </el-form-item>
          <el-form-item label="自定义字段" class="auto-height">
            <el-table
              :data="reservationRuleForm.fields"
              border
              class="fields-table"
            >
              <el-table-column prop="fieldType" label="字段类型">
                <template slot-scope="scope">
                  <el-select
                    v-model="scope.row.fieldType"
                    placeholder="请选择字段类型"
                    clearable
                  >
                    <el-option
                      v-for="item in fieldTypeOptions"
                      :key="item"
                      :label="item"
                      :value="item"
                    >
                    </el-option>
                  </el-select>
                </template>
              </el-table-column>
              <el-table-column prop="name" label="字段名称">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.name"
                    placeholder="请输入字段名称"
                    clearable
                    maxlength='6'
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column prop="content" label="选项/单位">
                <template slot-scope="scope">
                  <el-input
                    v-model="scope.row.content"
                    :placeholder="filterPlaceholder(scope.row.fieldType)"
                    clearable
                    v-if="
                      scope.row.fieldType == '下拉单选' ||
                      scope.row.fieldType == '下拉多选' ||
                      scope.row.fieldType == '数字输入'
                    "
                  ></el-input>
                  <span v-else>—</span>
                </template>
              </el-table-column>
              <el-table-column prop="isRequired" label="是否必填" width="110">
                <template slot-scope="scope">
                  <el-switch v-model="scope.row.isRequired"></el-switch
                  >{{ scope.row.isRequired ? "必填" : "非必填" }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="50" fixed="right">
                <template slot-scope="scope">
                  <div class="table-operation" v-if="!scope.row.isDefault">
                    <el-button
                      @click.native.prevent="delRuleField(scope.$index)"
                      type="text"
                      >删除</el-button
                    >
                  </div>
                  <div v-else>—</div>
                </template>
              </el-table-column>
            </el-table>
            <div class="add-field">
              <span class="error-tip" v-if="!isFieldsStatus"
                >请完整填写自定义字段表格</span
              >
              <span class="error-tip" v-if="isFiedldRepetitive"
                >自定义字段名称不得重复</span
              >
              <span @click="addField" class="theme-color"
                ><i class="el-icon-plus"></i>新增自定义字段</span
              >
            </div>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.reservationRule = false"
              >取 消</el-button
            >
            <el-button
              type="primary"
              @click="submitReservationRule"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="编辑来访规则"
        :visible.sync="isEditInfo.visitRule"
        @close="handleClose('visitRuleForm')"
      >
        <el-form
          label-position="left"
          label-width="7rem"
          ref="visitRuleForm"
          :rules="visitRules"
          :model="visitRuleForm"
        >
          <div class="flex-form">
            <el-form-item
              label="来访保护期"
              prop="protectedNumber"
              class="margin-right"
            >
              <el-input
                v-model="visitRuleForm.protectedNumber"
                placeholder="请输入来访保护期"
                clearable
                type="number"
              >
                <template slot="append">{{ visitUnit }}</template>
              </el-input>
            </el-form-item>
            <el-form-item label="有效期单位" prop="protectedUnit">
              <el-radio-group v-model="visitRuleForm.protectedUnit">
                <el-radio
                  v-for="item in protectedUnitOptions"
                  :label="item.value"
                  :key="item.label"
                  >{{ item.label }}</el-radio
                >
              </el-radio-group>
            </el-form-item>
          </div>
          <el-form-item label="来访登记" prop="registerType">
            <el-radio-group v-model="visitRuleForm.registerType">
              <el-radio
                v-for="item in registerTypeOptions"
                :label="item"
                :key="item"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="来访确认" prop="validationType">
            <el-radio-group v-model="visitRuleForm.validationType">
              <el-radio
                v-for="item in validationTypeOptions"
                :label="item"
                :key="item"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" class="auto-height" prop="more">
            <el-input
              type="textarea"
              v-model="visitRuleForm.more"
              placeholder="请输入备注"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.visitRule = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitVisitRule"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        title="编辑结佣规则"
        :visible.sync="isEditInfo.settlementRule"
        @close="handleClose('settlementRuleForm')"
      >
        <el-form
          label-position="left"
          label-width="7rem"
          ref="settlementRuleForm"
          :rules="settlementRules"
          :model="settlementRuleForm"
        >
          <el-form-item label="结佣方式" prop="settlementType">
            <el-radio-group v-model="settlementRuleForm.settlementType">
              <el-radio
                v-for="item in settlementTypeOptions"
                :label="item"
                :key="item"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="备注" class="auto-height" prop="more">
            <el-input
              type="textarea"
              v-model="settlementRuleForm.more"
              placeholder="请输入备注"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.settlementRule = false"
              >取 消</el-button
            >
            <el-button
              type="primary"
              @click="submitSettlementRule"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :title="awardTitle"
        :visible.sync="isEditInfo.award"
        @close="handleClose('awardForm')"
      >
        <el-form
          label-position="left"
          label-width="7rem"
          ref="awardForm"
          :rules="awardRules"
          :model="awardForm"
        >
          <el-form-item label="方案名称" prop="name">
            <el-input
              v-model="awardForm.name"
              placeholder="请输入奖励方案名称"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="奖励类型" prop="type">
            <el-radio-group v-model="awardForm.type">
              <el-radio
                v-for="item in awardTypeOptions"
                :label="item"
                :key="item"
                >{{ item }}</el-radio
              >
            </el-radio-group>
          </el-form-item>
          <el-form-item label="奖金金额" prop="amount">
            <el-input
              v-model="awardForm.amount"
              placeholder="请输入奖金金额"
              clearable
              type="number"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
          <el-form-item label="生效日期" prop="enableRange">
            <el-date-picker
              align="center"
              v-model="awardForm.enableRange"
              type="daterange"
              range-separator="~"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              :default-time="['00:00:00', '23:59:59']"
            ></el-date-picker>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.award = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitAwardForm"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <el-dialog
        :title="dynamicTitle"
        :visible.sync="isEditInfo.dynamic"
        @close="handleClose('dynamicForm')"
      >
        <el-form
          label-position="left"
          label-width="5rem"
          ref="dynamicForm"
          :rules="dynamicRules"
          :model="dynamicForm"
        >
          <el-form-item label="动态名称" prop="name">
            <el-input
              v-model="dynamicForm.name"
              placeholder="请输入动态名称"
              clearable
              class="width-input"
            >
            </el-input>
          </el-form-item>
          <el-form-item
            label="动态内容"
            class="auto-height dynamic-textarea"
            prop="content"
          >
            <el-input
              type="textarea"
              v-model="dynamicForm.content"
              placeholder="请输入动态内容"
              show-word-limit
              resize="none"
            ></el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.dynamic = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitDynamicForm"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
      <!-- 团购 -->
      <el-dialog
        :title="groupTitle"
        :visible.sync="isEditInfo.group"
        @close="handleClose('groupForm')"
      >
        <el-form
          label-position="left"
          label-width="7rem"
          ref="groupForm"
          :rules="groupRules"
          :model="groupForm"
        >
          <el-form-item label="方案名称" prop="name">
            <el-input
              v-model="groupForm.name"
              placeholder="请输入团购方案名称"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="结算方式" prop="type">
            <el-input
              v-model="groupForm.type"
              placeholder="请输入结算方式"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="团购方案" prop="content">
            <el-input
              v-model="groupForm.content"
              placeholder="请输入团购方案"
              clearable
            >
            </el-input>
          </el-form-item>
          <el-form-item label="团购金额" prop="amount">
            <el-input
              v-model="groupForm.amount"
              placeholder="请输入团购金额"
              clearable
              type="number"
            >
              <template slot="append">元</template>
            </el-input>
          </el-form-item>
        </el-form>
        <div slot="footer" class="dialog-footer">
          <div>
            <el-button @click="isEditInfo.group = false">取 消</el-button>
            <el-button
              type="primary"
              @click="submitGroupForm"
              :loading="isLoading"
              >确 定</el-button
            >
          </div>
        </div>
      </el-dialog>
    </div>
    <div v-if="isInit.isInit" class="loading-box">
      <img src="@/assets/image/loading.gif" />
    </div>
  </div>
</template>

<script>
import headerTop from "@/components/HeaderTop";
import videoPlay from "@/components/VideoPlay/index";
import { deepCopy } from "@/utils/deepCopy";
import { validatePhone } from "@/utils/validate";
import { dateFormat, filterValType } from "@/common/filters";
import {
  getCommissions,
  createCommission,
  updateCommission,
  updateCommissionDisable,
  deleteCommission,
  getReservationRule,
  updateReservationRule,
  getVisitRule,
  updateVisitRule,
  getSettlementRule,
  updateSettlementRule,
  getAwards,
  createAward,
  updateAward,
  deleteAward,
  updateAwardDisable,
  getDynamics,
  createDynamic,
  updateDynamic,
  publishDynamic,
  topDynamic,
  deleteDynamic,
  getGroups,
  createGroup,
  updateGroup,
  deleteGroup,
  updateGroupDisable,
} from "@/http/api/marketing";

export default {
  components: {
    videoPlay,
    headerTop,
  },
  data() {
    const validatePhoneNumber = (rule, value, callback) => {
      if (!value) {
        callback();
      } else if (!validatePhone(value)) {
        callback(new Error("手机号输入不合法"));
      } else {
        callback();
      }
    };
    return {
      estateId: "",
      permissions: [],
      groups: [],
      zoom: 3,
      commissionPlanTitle: "",
      awardTitle: "",
      groupTitle: "",
      dynamicTitle: "",
      isLoading: false,
      isTopVisible: false,
      isFieldsStatus: true,
      isFiedldRepetitive: false,
      initInterval: null,
      maxResultCount: 20,
      pageIndex: 1,
      totalCount: 0,
      elTop: {
        marketingHeight: 0,
        marketingItems: 0,
        commissionPlan: 0,
        projectRule: 0,
        award: 0,
        dynamic: 0,
        estateGroup: 0,
        estateType: 0,
        estatePhotos: 0,
        estateVr: 0,
        estateFile: 0,
        preSellCards: 0,
      }, // 各盒子到顶部的距离
      isInit: {
        commissionPlan: false,
        reservationRule: false,
        settlementRule: false,
        visitRule: false,
        award: false,
        dynamic: false,
        estateGroup: false,
        isInit: true,
      },
      commissionPlanForm: {
        name: "",
        type: "按套",
        amount: "",
        rule: "",
      },
      commissionPlanRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入方案名称",
          },
        ],
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择佣金类型",
          },
        ],
        amount: [
          {
            required: true,
            trigger: "blur",
            message: "请输入佣金金额",
          },
        ],
        rule: [
          {
            required: true,
            trigger: "blur",
            message: "请输入佣金规则",
          },
        ],
      },
      groupRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入方案名称",
          },
        ],
        type: [
          {
            required: true,
            trigger: "change",
            message: "请输入结算方式",
          },
        ],
        content: [
          {
            required: true,
            trigger: "blur",
            message: "请输入团购方案",
          },
        ],
      },
      reservationRuleForm: {
        numberType: "",
        protectedNumber: "",
        protectedUnit: "day",
        more: "",
      },
      creservationRules: {
        numberType: [
          {
            required: true,
            trigger: "change",
            message: "请选择报备号码",
          },
        ],
        protectedNumber: [
          {
            required: true,
            trigger: "blur",
            message: "请输入报备有效期",
          },
        ],
        protectedUnit: [
          {
            required: true,
            trigger: "change",
            message: "请选择有效期单位",
          },
        ],
        more: [
          {
            required: true,
            trigger: "blur",
            message: "请输入报备注意事项",
          },
        ],
      },
      visitRuleForm: {
        protectedNumber: "",
        protectedUnit: "day",
        registerType: "",
        validationType: "",
        more: "",
      },
      visitRules: {
        protectedNumber: [
          {
            required: true,
            trigger: "blur",
            message: "请输入来访保护期",
          },
        ],
        registerType: [
          {
            required: true,
            trigger: "change",
            message: "请选择来访登记",
          },
        ],
        protectedUnit: [
          {
            required: true,
            trigger: "change",
            message: "请选择有效期单位",
          },
        ],
        validationType: [
          {
            required: true,
            trigger: "change",
            message: "请选择来访确认",
          },
        ],
        more: [
          {
            required: true,
            trigger: "blur",
            message: "请输入备注",
          },
        ],
      },
      settlementRuleForm: {
        settlementType: "大定结佣",
        more: "",
      },
      settlementRules: {
        more: [
          {
            required: true,
            trigger: "blur",
            message: "请输入备注",
          },
        ],
        settlementType: [
          {
            required: true,
            trigger: "change",
            message: "请选择结佣方式",
          },
        ],
      },
      dynamicForm: {
        name: "",
        content: "",
      },
      dynamicRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入动态名称",
          },
        ],
        content: [
          {
            required: true,
            trigger: "blur",
            message: "请输入动态内容",
          },
        ],
      },
      isEditInfo: {
        commissionPlan: false,
        reservationRule: false,
        settlementRule: false,
        visitRule: false,
        award: false,
        dynamic: false,
        group: false,
      },
      reservationRule: {
        protectedUnit: "天",
        numberType: "",
        protectedNumber: "",
        more: "",
        fields: [],
      },
      settlementRule: {
        settlementType: "大定结佣",
        more: "",
      },
      visitRule: {
        protectedUnit: "天",
        registerType: "",
        validationType: "",
        more: "",
        protectedNumber: "",
      },
      awardForm: {
        type: "其他",
        amount: "",
        enableStartTime: "",
        enableEndTime: "",
        enableRange: [],
      },
      groupForm: {
        name: "",
        content: "",
        type: "",
        amount: "",
      },
      awardRules: {
        name: [
          {
            required: true,
            trigger: "blur",
            message: "请输入奖励方案名称",
          },
        ],
        amount: [
          {
            required: true,
            trigger: "blur",
            message: "请输入奖励金额",
          },
        ],
        type: [
          {
            required: true,
            trigger: "change",
            message: "请选择奖励类型",
          },
        ],
        enableRange: [
          {
            required: true,
            trigger: "change",
            message: "请选择生效时间",
          },
        ],
      },
      awards: [],
      dynamics: [],
      marketingItems: [
        {
          name: "佣金方案",
          isActive: true,
          status: true,
        },
        {
          name: "项目规则",
          isActive: false,
          status: true,
        },
        {
          name: "奖励方案",
          isActive: false,
          status: true,
        },
        {
          name: "项目动态",
          isActive: false,
          status: true,
        },
        {
          name: "团购方案",
          isActive: false,
          status: true,
        },
      ],
      commissions: [],
      commissionTypeOptions: ["按套", "按比例"],
      protectedUnitOptions: [
        { label: "天", value: "day" },
        { label: "时", value: "hour" },
      ],
      numberTypeOptions: {},
      registerTypeOptions: ["客户全号登记", "客户隐号登记", "无需登记", "其他"],
      validationTypeOptions: [
        "需要开发商确认",
        "需要第三方确认",
        "无需确认",
        "其他",
      ],
      settlementTypeOptions: [
        "大定结佣",
        "签约结佣",
        "回款结佣",
        "按揭结佣",
        "首付交齐",
        "其他",
      ],
      fieldTypeOptions: [
        "文本输入",
        "下拉单选",
        "下拉多选",
        "日期选择",
        "数字输入",
        "上传附件",
      ],
      awardTypeOptions: ["带看奖", "成交奖", "其他"],
    };
  },
  computed: {
    commissionAmountUnit() {
      return this.commissionPlanForm.type == "按套" ? "元" : "%";
    },
    reservationUnit() {
      return this.reservationRuleForm.protectedUnit == "day" ? "天" : "时";
    },
    visitUnit() {
      return this.visitRuleForm.protectedUnit == "day" ? "天" : "时";
    },
  },
  mounted() {
    this.numberTypeOptions = this.$store.getters.enumMetadata.EstateReservationNumberType;
    this.permissions = this.$store.getters.permissions;
  },
  methods: {
    filterPlaceholder(v) {
      let value = "";
      if (v == "下拉单选" || v == "下拉多选") {
        value = "请输入选项，用；分割";
      } else if (v == "数字输入") {
        value = "请输入单位";
      }
      return value;
    },
    // 新增自定义字段
    addField() {
      this.reservationRuleForm.fields.push({
        name: "",
        fieldType: "",
        content: "",
        savedContent: "",
        isDefault: false,
        isRequired: false,
      });
    },
    // 删除报备规则自定义字段
    delRuleField(i) {
      this.reservationRuleForm.fields.splice(i, 1);
    },
    // 删除项目动态
    deleteDynamic(id) {
      this.$confirm(
        `删除项目动态后，该动态所展示的内容一并删除，确认删除吗？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          deleteDynamic(this.estateId, id).then((res) => {
            this.getDynamics();
            if (res) {
              this.$message.success({
                message: "删除成功",
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 置顶项目动态
    topDynamic(id) {
      this.$confirm(`置顶后该动态将在第一条展示，确认置顶？`, "温馨提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
      })
        .then(() => {
          topDynamic(this.estateId, id).then((res) => {
            this.getDynamics();
            if (res) {
              this.$message.success({
                message: "置顶成功",
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 发布项目动态
    publishDynamic(id) {
      this.$confirm(
        `发布动态后，可在新房楼盘详情内查看该动态内容，确认发布？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          publishDynamic(this.estateId, id).then((res) => {
            this.getDynamics();
            if (res) {
              this.$message.success({
                message: "发布成功",
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 编辑项目动态
    editDynamic(v) {
      this.dynamicTitle = "编辑项目动态";
      this.dynamicForm = deepCopy(v);
      this.isEditInfo.dynamic = true;
    },
    // 提交项目动态表单
    submitDynamicForm() {
      this.$refs["dynamicForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.dynamicForm);
          if (this.dynamicTitle == "添加项目动态") {
            createDynamic(this.estateId, data)
              .then((res) => {
                this.getDynamics();
                this.isEditInfo.dynamic = false;
                if (res) {
                  this.$message.success({
                    message: res.message,
                    showClose: true,
                  });
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            updateDynamic(this.estateId, data)
              .then((res) => {
                this.getDynamics();
                this.isEditInfo.dynamic = false;
                if (res) {
                  this.$message.success({
                    message: res.message,
                    showClose: true,
                  });
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 更改的页面数量
    handleSizeChange(val) {
      this.maxResultCount = val;
      this.getDynamics();
    },
    // 跳转的指定页
    handleCurrentChange(val) {
      this.pageIndex = val;
      this.getDynamics();
    },
    // 获取项目动态
    getDynamics() {
      let query = {
        maxResultCount: this.maxResultCount,
        skipCount: (this.pageIndex - 1) * this.maxResultCount,
      };
      getDynamics(this.estateId, query).then((res) => {
        this.dynamics = res.result.items;
        this.totalCount = res.result.totalCount;
        this.isInit.dynamic = true;
      });
    },
    // 提交奖励方案表单
    submitAwardForm() {
      this.$refs["awardForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.awardForm);
          data.enableStartTime = dateFormat(data.enableRange[0]);
          data.enableEndTime = dateFormat(data.enableRange[1]);
          delete data.enableRange;
          if (this.awardTitle == "添加奖励方案") {
            createAward(this.estateId, data)
              .then((res) => {
                if (res.code == 10200) {
                  this.getAwards();
                  this.isEditInfo.visitRule = false;
                  this.$message.success({
                    message: res.message,
                    showClose: true,
                  });
                  this.isEditInfo.award = false;
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            updateAward(this.estateId, data)
              .then((res) => {
                if (res.code == 10200) {
                  this.getAwards();
                  this.isEditInfo.visitRule = false;
                  this.$message.success({
                    message: res.message,
                    showClose: true,
                  });
                  this.isEditInfo.award = false;
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 编辑奖励方案
    editAward(v) {
      this.awardForm = deepCopy(v);
      this.commissionPlanTitle = "编辑项目动态";
      if (v.enableStartTime && v.enableEndTime) {
        this.awardForm.enableRange = [v.enableStartTime, v.enableEndTime];
      }
      this.isEditInfo.award = true;
    },
    // 获取奖励方案列表
    getAwards() {
      getAwards(this.estateId).then((res) => {
        this.awards = res.result.items;
        this.isInit.award = true;
      });
    },
    // 隐藏奖励方案
    updateAwardDisable(id, status) {
      let text = status ? "显示" : "隐藏";
      this.$confirm(
        `该奖励方案将在楼盘详情中${text}，确认${text}吗？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          updateAwardDisable(this.estateId, id, !status).then((res) => {
            this.getAwards();
            if (res) {
              this.$message.success({
                message: `${text}成功`,
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 删除奖励方案
    delAward(id) {
      this.$confirm(
        `删除奖励方案后，该方案所展示的内容一并删除，确认删除吗？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          deleteAward(this.estateId, id).then((res) => {
            this.getAwards();
            if (res) {
              this.$message.success({
                message: "删除成功",
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 提交结佣规则表单
    submitSettlementRule() {
      this.$refs["settlementRuleForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.settlementRuleForm);
          updateSettlementRule(this.estateId, data)
            .then((res) => {
              this.getSettlementRule();
              this.isEditInfo.settlementRule = false;
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
              }
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 提交来访规则表单
    submitVisitRule() {
      this.$refs["visitRuleForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.visitRuleForm);
          updateVisitRule(this.estateId, data)
            .then((res) => {
              this.getVisitRule();
              this.isEditInfo.visitRule = false;
              if (res) {
                this.$message.success({
                  message: res.message,
                  showClose: true,
                });
              }
              this.isLoading = false;
            })
            .catch(() => {
              this.isLoading = false;
            });
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 提交报备规则表单
    submitReservationRule() {
      this.$refs["reservationRuleForm"].validate((valid) => {
        if (valid) {
          this.isFieldsStatus = true;
          this.isFiedldRepetitive = false;
          let data = deepCopy(this.reservationRuleForm);
          let arr = [];
          data.fields.map((el) => {
            el.name = el.name.trim();
            el.content = el.content.trim();
            arr.push(el.name);
            if (!el.name || !el.fieldType) {
              this.isFieldsStatus = false;
            }
            if (
              el.fieldType == "下拉单选" ||
              el.fieldType == "下拉多选" ||
              el.fieldType == "数字输入"
            ) {
              if (!el.content) {
                this.isFieldsStatus = false;
              }
            }
          });
          if (this.isFieldsStatus) {
            if (new Set(arr).size != arr.length) {
              this.isFiedldRepetitive = true;
            }
            if (!this.isFiedldRepetitive) {
              this.isLoading = true;
              updateReservationRule(this.estateId, data)
                .then((res) => {
                  this.getReservationRule();
                  this.isEditInfo.reservationRule = false;
                  if (res) {
                    this.$message.success({
                      message: res.message,
                      showClose: true,
                    });
                  }
                  this.isLoading = false;
                })
                .catch(() => {
                  this.isLoading = false;
                });
            }
          }
        } else {
          return false;
        }
      });
    },
    // 获取结佣规则
    getSettlementRule() {
      getSettlementRule(this.estateId).then((res) => {
        if (res.result.settlementType) {
          this.settlementRule = res.result;
        }
        this.isInit.settlementRule = true;
      });
    },
    // 获取来访规则
    getVisitRule() {
      getVisitRule(this.estateId).then((res) => {
        if (res.result.protectedUnit) {
          this.visitRule = res.result;
        }
        this.isInit.visitRule = true;
      });
    },
    // 获取报备规则
    getReservationRule() {
      getReservationRule(this.estateId).then((res) => {
        if (res.result.protectedUnit) {
          this.reservationRule = res.result;
        }
        console.log(this.reservationRule, "this.reservationRule");
        this.isInit.reservationRule = true;
      });
    },
    // 隐藏佣金方案
    updateCommissionDisable(id, status) {
      let text = status ? "显示" : "隐藏";
      this.$confirm(
        `该佣金方案将在楼盘详情中${text}，确认${text}吗？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          updateCommissionDisable(this.estateId, id, !status).then((res) => {
            this.getCommissionPlans();
            if (res) {
              this.$message.success({
                message: `${text}成功`,
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 提交佣金规则表单
    submitCommissionPlan() {
      this.$refs["commissionPlanForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.commissionPlanForm);
          if (this.commissionPlanTitle == "添加佣金方案") {
            createCommission(this.estateId, data)
              .then((res) => {
                this.getCommissionPlans();
                this.isEditInfo.commissionPlan = false;
                if (res) {
                  this.$message.success({
                    message: "添加成功",
                    showClose: true,
                  });
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            updateCommission(this.estateId, data)
              .then((res) => {
                this.getCommissionPlans();
                this.isEditInfo.commissionPlan = false;
                if (res) {
                  this.$message.success({
                    message: res.message,
                    showClose: true,
                  });
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 删除佣金方案
    delCommissionPlan(id) {
      this.$confirm(
        `删除佣金方案后，该方案所展示的内容一并删除，确认删除吗？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          deleteCommission(this.estateId, id).then((res) => {
            this.getCommissionPlans();
            if (res) {
              this.$message.success({
                message: "删除成功",
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 编辑佣金方案
    editCommissionPlan(v) {
      this.commissionPlanForm = deepCopy(v);
      this.commissionPlanTitle = "编辑佣金方案";
      this.isEditInfo.commissionPlan = true;
    },
    // 获取佣金方案列表
    getCommissionPlans() {
      this.estateId = this.$route.params.id;
      getCommissions(this.estateId).then((res) => {
        this.commissions = res.result.items;
        this.isInit.commissionPlan = true;
      });
    },
    // 弹窗关闭回调
    handleClose(formName) {
      this.$refs[formName].resetFields();
      Object.assign(this.$data[formName], this.$options.data()[formName]);
    },
    // 编辑模块
    editModule(v) {
      //console.log(v);
      if (this.permissions["Estate.Update"]) {
        switch (v) {
          case "commissionPlan":
            this.commissionPlanTitle = "添加佣金方案";
            break;
          case "reservationRule":
            this.reservationRuleForm = deepCopy(this.reservationRule);
            this.reservationRuleForm.numberType = filterValType(
              this.reservationRuleForm.numberType,
              this.numberTypeOptions,
              "val"
            );
            this.reservationRuleForm.protectedUnit =
              this.reservationRuleForm.protectedUnit == "天" ? "day" : "hour";
            break;
          case "visitRule":
            this.visitRuleForm = deepCopy(this.visitRule);
            this.visitRuleForm.protectedUnit =
              this.visitRuleForm.protectedUnit == "天" ? "day" : "hour";
            break;
          case "settlementRule":
            this.settlementRuleForm = deepCopy(this.settlementRule);
            break;
          case "award":
            this.awardTitle = "添加奖励方案";
            break;
          case "dynamic":
            this.dynamicTitle = "添加项目动态";
            break;
          case "group":
            this.groupTitle = "添加团购方案";
            break;
        }
        this.isEditInfo[v] = true;
      } else {
        this.$message.warning({
          message: "您暂无管理楼盘权限",
          showClose: true,
        });
      }
    },
    // 提交奖励方案表单
    submitGroupForm() {
      this.$refs["groupForm"].validate((valid) => {
        if (valid) {
          this.isLoading = true;
          let data = deepCopy(this.groupForm);

          if (this.groupTitle == "添加团购方案") {
            createGroup(this.estateId, data)
              .then((res) => {
                if (res.code == 10200) {
                  this.getGroups();
                  this.isEditInfo.visitRule = false;
                  this.$message.success({
                    message: res.message,
                    showClose: true,
                  });
                  this.isEditInfo.group = false;
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          } else {
            updateGroup(this.estateId, data)
              .then((res) => {
                if (res.code == 10200) {
                  this.getGroups();
                  this.isEditInfo.visitRule = false;
                  this.$message.success({
                    message: res.message,
                    showClose: true,
                  });
                  this.isEditInfo.group = false;
                }
                this.isLoading = false;
              })
              .catch(() => {
                this.isLoading = false;
              });
          }
        } else {
          //console.log("表单验证未通过");
          return false;
        }
      });
    },
    // 编辑奖励方案
    editGroup(v) {
      this.groupForm = deepCopy(v);
      this.commissionPlanTitle = "编辑项目动态";
      if (v.enableStartTime && v.enableEndTime) {
        this.groupForm.enableRange = [v.enableStartTime, v.enableEndTime];
      }
      this.isEditInfo.group = true;
    },
    // 获取奖励方案列表
    getGroups() {
      getGroups(this.estateId).then((res) => {
        this.groups = res.result.items;
        this.isInit.estateGroup = true;
      });
    },
    // 隐藏奖励方案
    updateGroupDisable(id, status) {
      let text = status ? "显示" : "隐藏";
      this.$confirm(
        `该团购方案将在楼盘详情中${text}，确认${text}吗？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          updateGroupDisable(this.estateId, id, !status).then((res) => {
            this.getGroups();
            if (res) {
              this.$message.success({
                message: `${text}成功`,
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 删除团购方案
    delGroup(id) {
      this.$confirm(
        `删除团购方案后，该方案所展示的内容一并删除，确认删除吗？`,
        "温馨提示",
        {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
        }
      )
        .then(() => {
          deleteGroup(this.estateId, id).then((res) => {
            this.getGroups();
            if (res) {
              this.$message.success({
                message: "删除成功",
                showClose: true,
              });
            }
          });
        })
        .catch(() => {
          //console.log("已取消");
        });
    },
    // 定位模块
    marketingItemChange(v) {
      //console.log(v, "huoqudev");
      let el = document.querySelector(".main-container");
      switch (v.name) {
        case "佣金方案":
          el.scrollTop = 0;
          break;
        case "项目规则":
          el.scrollTop = this.elTop.projectRule - this.elTop.marketingHeight;
          break;
        case "奖励方案":
          el.scrollTop = this.elTop.award - this.elTop.marketingHeight;
          break;
        case "项目动态":
          el.scrollTop = this.elTop.dynamic - this.elTop.marketingHeight;
          break;
        case "团购方案":
          el.scrollTop = this.elTop.estateGroup - this.elTop.marketingHeight;
          break;
      }
    },
    // 初始化数据
    initData() {
      this.getCommissionPlans();
      this.getReservationRule();
      this.getSettlementRule();
      this.getDynamics();
      this.getVisitRule();
      this.getAwards();
      this.getGroups();
      this.initInterval = setInterval(() => {
        this.initScroll();
      }, 500);
    },

    // 初始化滚动动画
    initScroll() {
      if (this.elTop.estateGroup != 0) {
        clearInterval(this.initInterval); //停止
      }
      try {
        if (
          this.isInit.commissionPlan &&
          this.isInit.reservationRule &&
          this.isInit.visitRule &&
          this.isInit.settlementRule &&
          this.isInit.award &&
          this.isInit.dynamic &&
          this.isInit.estateGroup
        ) {
          this.isInit.isInit = false;
          let el = document.querySelector(".main-container");
          el.addEventListener("scroll", this.scrollScreen);
          this.$nextTick(() => {
            this.elTop.marketingHeight = this.$refs.marketingItems.offsetHeight;
            this.elTop.marketingItems = this.$refs.marketingItems.getBoundingClientRect().top;
            this.elTop.commissionPlan =
              this.$refs.commissionPlan.getBoundingClientRect().top -
              this.elTop.marketingHeight;
            this.elTop.projectRule =
              this.$refs.projectRule.getBoundingClientRect().top -
              this.elTop.marketingHeight;
            this.elTop.award =
              this.$refs.award.getBoundingClientRect().top -
              this.elTop.marketingHeight;
            this.elTop.dynamic =
              this.$refs.dynamic.getBoundingClientRect().top -
              this.elTop.marketingHeight;
            this.elTop.estateGroup =
              this.$refs.estateGroup.getBoundingClientRect().top -
              this.elTop.marketingHeight;
          });
        }
      } catch (error) {
        clearInterval(this.initInterval); //停止
      }
    },
    // 头部滚动样式
    scrollScreen() {
      let top =
        document.querySelector(".main-container").scrollTop +
        this.elTop.marketingHeight;
      if (top < this.elTop.projectRule) {
        this.marketingActive("佣金方案");
      } else if (top >= this.elTop.projectRule && top < this.elTop.award) {
        this.marketingActive("项目规则");
      } else if (top >= this.elTop.award && top < this.elTop.dynamic) {
        this.marketingActive("奖励方案");
      } else if (top >= this.elTop.dynamic && top < this.elTop.estateGroup) {
        this.marketingActive("项目动态");
      } else if (top >= this.elTop.estateGroup && top < this.elTop.estateType) {
        this.marketingActive("团购方案");
      }
      // //console.log(top,"top",this.elTop.marketingItems);
      if (top > this.elTop.marketingItems) {
        this.isTopVisible = true;
      } else {
        this.isTopVisible = false;
      }
    },
    // 激活头部项目
    marketingActive(v) {
      this.marketingItems.map((el) => {
        if (el.name == v) {
          el.isActive = true;
        } else {
          el.isActive = false;
        }
      });
    },
  },
};
</script>
<style lang="scss" scoped>
@import "@/styles/mixin.scss";

.marketing-info {
  .fixed-top {
    visibility: hidden;
    position: fixed;
    top: 48px;
    width: 100%;
    background-color: #f7f7f7;
    z-index: 6;
    box-shadow: 0 2px 3px rgba(0, 0, 0, 0.2);
  }

  .is-visible {
    visibility: visible;
  }

  .marketing-items {
    display: flex;
    align-items: center;
    padding: 20px;

    .marketing-item {
      margin-right: 30px;
      color: #666;
      cursor: pointer;

      .el-icon-success {
        margin-left: 5px;
        color: #c4cdd5;
      }

      .isactive,
      .success-icon {
        color: $--color-primary;
      }
    }
  }

  .detail-main {
    margin: 20px;
    margin-top: 0;

    .detail-item {
      margin-bottom: 20px;
      border-radius: $--border-radius-base;
      background-color: #fff;

      .detail-title {
        display: flex;
        justify-content: space-between;

        padding: 20px;
        font-size: 16px;
        border-bottom: 1px solid #e0e0e0;

        .edit-btn {
          color: $--color-primary;
          cursor: pointer;
        }
      }

      .detail-item-main {
        padding: 20px;

        .rule-box {
          display: flex;
          padding-top: 33px;

          &:first-child {
            padding-top: 13px;
          }

          .rule-title {
            width: 70px;
            font-weight: 400;
            color: #666;
          }

          .rule-items {
            border-bottom: 1px solid #e0e0e0;
            padding-right: 20px;
            width: calc(100% - 70px);
            color: #000;

            div {
              margin-bottom: 20px;
            }

            .rule-item {
              margin-right: 20px;
            }

            .fields-value {
              span {
                display: inline-block;
                margin: 0 5px;
              }
            }

            .rule-btn {
              margin-top: 20px;
              margin-bottom: 40px;
              margin-left: 40px;
              width: 30px;
              font-size: 15px;
              color: $--color-primary;
              white-space: nowrap;
              cursor: pointer;
            }
          }

        }

        .pagination {
          margin-top: 20px;
        }

        .item-value {
          margin-right: 10px;
        }
      }

      .project-counselor{
        padding-right: 0;
      }

      .margin-bottom {
        margin-bottom: 0;
      }
    }
  }

  .el-dialog {
    .el-input {
      width: 247px;
    }

    .flex-form {
      display: flex;

      .margin-right {
        margin-right: 100px;
      }
    }

    .dynamic-textarea {
      width: 600px;
    }

    .fields-table {
      width: 800px;
      margin-bottom: 10px;

      .el-switch {
        margin-right: 5px;
      }

      .el-input {
        width: 100%;
      }
    }

    .add-field {
      position: relative;
      text-align: center;

      .error-tip {
        position: absolute;
        left: 0;
        top: -15px;
        font-size: 12px;
        color: #f56c6c;
      }
    }

    .width-input{
      width: 100%;
    }
  }
}

.loading-box {
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - 132px);
  background-color: #fff;

  img {
    margin-top: -40px;
    width: 200px;
    height: auto;
  }
}
</style>